



























import { Vue, Component, Prop } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

import { EPaymentMethod } from '@/helpers/enums';

const CheckoutModule = namespace('App/Checkout');

@Component
export default class PixContent extends Vue {
  @Prop()
  private readonly pix: any;

  @CheckoutModule.Getter('selectedOfferDiscountByPaymentMethod')
  private discountByPaymentMethod: any;

  private get labelDiscount() {
    return this.$t(`App.Checkout.Payment.discount.paymentsMethods.${EPaymentMethod.pix}`);
  }

  private get showLabelDiscount() {
    return this.discountByPaymentMethod(EPaymentMethod.pix);
  }
}
